import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import PracticalTraining from '../components/Practicaltraining.vue'
import Test from '../components/test.vue'
import Knowledge from '../components/Knowledge.vue'
import Mon from '../components/mon.vue'
import Theory from '../components/theory.vue'


Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/knowledge' },
    { path: '/login', component: Login },
    { path: '/home', component: Home },
    { path: '/practicaltraining', component: PracticalTraining },
    { path: '/test', component: Test },
    { path: '/knowledge', component: Knowledge },
    { path: '/mon', component: Mon },
    { path: '/theory', component: Theory }
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/home')  强制跳转

  if (to.path === '/home') return next()
  if (to.path === '/test') return next()
  if (to.path === '/login') return next()
  if (to.path === '/knowledge') return next()
  if (to.path === '/mon') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
